/**
 * Motivo da falha de uma tentativa ou execução da Tabela IBPT. Mesmos ids do catálogo
 * db_motor_fiscal.ibpt_motivo_falha_execucao.
 */
export enum IbptMotivoFalhaExecucaoEnum {
    SemRespostaApi = 1,
    CredenciaisRecusadas = 2,
    ItensComErroAcimaLimite = 3,
    ErroGravacao = 4,
    ErroInesperado = 5,
}
